import { z } from 'zod';

export const redeemRewardItemSchema = z.object({
  code: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
});

export type RedeemRewardItemValidationSchema = z.infer<typeof redeemRewardItemSchema>;
